// extracted by mini-css-extract-plugin
export var content = "LogIn-module__content___GCOr4";
export var grid = "LogIn-module__grid___iS4Bi";